import { render } from "./gsrcu0101.vue?vue&type=template&id=fad29622&scoped=true"
import script from "./gsrcu0101.vue?vue&type=script&lang=js"
export * from "./gsrcu0101.vue?vue&type=script&lang=js"

import "./gsrcu0101.vue?vue&type=style&index=0&id=fad29622&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fad29622"]])

export default __exports__